// Setup password for Google-only users - calls Rails backend directly

document.addEventListener('turbo:load', () => {
  const setupForm = document.getElementById('setup-password-form');
  
  if (setupForm) {
    const token = setupForm.dataset.token;
    const locale = window.location.pathname.split('/')[1] || 'el';
    const errorDiv = document.getElementById('error-message');
    const successDiv = document.getElementById('success-message');

    setupForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      showLoading(true);
      hideMessages();

      const password = document.getElementById('new-password').value;
      const passwordConfirmation = document.getElementById('confirm-password').value;

      if (password !== passwordConfirmation) {
        showLoading(false);
        showError(window.I18n?.['auth.errors.passwords_dont_match'] || 'Passwords do not match');
        return;
      }

      if (password.length < 8) {
        showLoading(false);
        showError(window.I18n?.['auth.errors.weak_password'] || 'Password must be at least 8 characters');
        return;
      }

      try {
        const response = await fetch(`/${locale}/setup-password/${token}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
          },
          body: JSON.stringify({ password, password_confirmation: passwordConfirmation })
        });

        const data = await response.json();
        
        if (data.success) {
          showSuccess(window.I18n?.['auth.password_setup_success'] || 'Password set successfully! Redirecting to login...');
          setTimeout(() => {
            window.location.href = `/${locale}/login`;
          }, 2000);
        } else {
          showLoading(false);
          showError(data.error);
        }

      } catch (error) {
        console.error('Setup password error:', error);
        showLoading(false);
        showError(window.I18n?.['auth.errors.auth_failed'] || 'Failed to set password. Please try again.');
      }
    });

    function showError(message) {
      if (errorDiv) {
        errorDiv.textContent = message;
        errorDiv.classList.remove('hidden');
      }
    }

    function showSuccess(message) {
      if (successDiv) {
        successDiv.textContent = message;
        successDiv.classList.remove('hidden');
      }
    }

    function hideMessages() {
      errorDiv?.classList.add('hidden');
      successDiv?.classList.add('hidden');
    }

    function showLoading(loading) {
      const btnText = document.getElementById('setup-btn-text');
      const btnLoading = document.getElementById('setup-btn-loading');
      
      if (loading) {
        btnText?.classList.add('hidden');
        btnLoading?.classList.remove('hidden');
      } else {
        btnText?.classList.remove('hidden');
        btnLoading?.classList.add('hidden');
      }
    }
  }
});
